/**
 * `<html lang>` sigue al idioma de la interfaz (WCAG 3.1.1): los lectores de
 * pantalla eligen la pronunciación con él. `index.html` trae `lang="es"` sólo
 * para el instante previo a que cargue el bundle.
 *
 * Vive aparte de `config.ts` porque ese módulo también lo importan helpers y
 * tests sin DOM; escribir en el documento es responsabilidad del bootstrap
 * del navegador (`main.tsx`), que llama esto una sola vez.
 *
 * Con los recursos en línea, i18next resuelve el idioma inicial de forma
 * síncrona dentro de `init()`, antes de que este módulo pueda escucharlo; por
 * eso se aplica el idioma ya resuelto y luego se escucha cada cambio.
 */

import type { i18n as I18n } from 'i18next'

import { DEFAULT_LOCALE, normalizeLocale } from './config'

export function bindDocumentLang(instance: I18n, root: Pick<HTMLElement, 'lang'>): void {
  root.lang = normalizeLocale(instance.resolvedLanguage ?? DEFAULT_LOCALE)
  instance.on('languageChanged', (lng) => {
    root.lang = normalizeLocale(lng)
  })
}
